import React, { Children, useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { closeModal } from '@krea/common/store/modal/actions'
import { Button } from '@krea/common/shared-components'
import { DialogActions, DialogContent } from '@krea/common/shared-components/dialog'
import { get } from 'lodash'
import { changeCurrentLoanApplication } from '../../../store/current-loan-application/actions'

import { ApplicationsSelectorItem, ApplicationsSelectorList } from '../applications-selector'

import { useTranslation } from 'react-i18next'
import { fetchLoanApplicationsData } from 'store/loan-applications/actions'

const ChangeApplicationModal = ({ currentLoanApplicationId, activeLoanApplications }) => {
	const dispatch = useDispatch()

	useEffect(() => {
		dispatch(fetchLoanApplicationsData())
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const onChangeCurrentApplication = (id) => {
		if (currentLoanApplicationId !== id) {
			dispatch(changeCurrentLoanApplication(id))
		}
	}

	const onCloseModal = () => {
		dispatch(closeModal())
	}

	const { t } = useTranslation()

	return (
		<>
			<DialogContent>
				<ApplicationsSelectorList>
					{Children.toArray(
						activeLoanApplications.map((item) => (
							<>
								<ApplicationsSelectorItem
									data={item}
									checked={item.id === currentLoanApplicationId}
									onClick={() => onChangeCurrentApplication(item.id)}
								/>
							</>
						))
					)}
				</ApplicationsSelectorList>
			</DialogContent>
			<DialogActions>
				<Button variant="text" onClick={onCloseModal} id="modal-cancel-button">
					{t('applicationSelector.cancel')}
				</Button>
			</DialogActions>
		</>
	)
}

const mapStateToProps = (state) => ({
	currentLoanApplicationId: get(state.currentLoanApplicationReducer, 'currentLoanApplication.id'),
	activeLoanApplications: get(state.loanApplicationsReducer, 'loanApplications', [])
})

export default connect(mapStateToProps)(ChangeApplicationModal)
